import React from "react";
import Layout from "../Layout";
import ScriptDetailsSidebar from "../../../widgets/management/script-details/ScriptDetails";
// import ScriptDetailsSidebar from "../../../widgets/management/script-details/ScriptDetails";

function ScriptDetails(props) {
  return (
    <Layout>
      <ScriptDetailsSidebar />
    </Layout>
  );
}

export default ScriptDetails;
